import React from 'react'
import { useNavigate } from 'react-router-dom'
import { faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import { OrdersContext } from 'contexts/OrdersContext'
import _ from 'lodash'
import {
  DcBreadcrumbs,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  PixelCurrency,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  Section,
  SectionContent,
} from 'pixel-base'
import queryString from 'query-string'
import { getCourierBookings } from 'utils/api-routes.util'

import UpdateCourierBookingPayments from './components/UpdateCourierBookingPayments'

const breadcrumbs = [
  {
    name: 'Bookings',
    active: true,
  },
]
const bookingsTypeFilter = [
  {
    label: 'All Bookings',
    value: '0',
  },
  {
    label: 'In Progress Booking',
    value: '1',
  },
]
const Bookings = () => {
  const [courierSummary, setCourierSummary] = React.useState([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [searchValue, setSearchValue] = React.useState('')
  const { state } = React.useContext(OrdersContext)
  const [totalRows, setTotalRows] = React.useState(0)
  const [courierList, setCourierList] = React.useState([])
  const [riderList, setRiderList] = React.useState([])
  const p = queryString.parse(window.location.search)
  const [filters, setFilters] = React.useState<any>({
    search: p.search || '',
    page: p.page || null,
    page_size: p.page_size || null,
    to_be_delivered: p.to_be_delivered || null,
    courier_id: p.courier_id || null,
  })

  const [selectedBooking, setSelectedBooking] = React.useState<any>({})
  const [showModal, setShowModal] = React.useState(false)
  const navigate = useNavigate()
  const onlyAppliedFilters = (filters) => {
    const appliedFilters = {}
    Object.keys(filters).map((key) => {
      if (filters[key]) {
        if (key === 'search') {
          appliedFilters[key] = filters[key]
        } else {
          appliedFilters[key] = filters[key]
        }
      }
    })
    return appliedFilters
  }
  const debounceFn = React.useCallback(
    _.debounce((value) => {
      setFilters({
        ...filters,
        search: value,
      })
    }, 1000),
    [filters],
  )
  React.useEffect(() => {
    navigate({
      pathname: '/payments/bookings',
      search: queryString.stringify(onlyAppliedFilters(filters)),
    })
    getAllCourierSummary()
  }, [filters])
  React.useEffect(() => {
    setCourierList(state?.couriers)
  }, [state])
  const getAllCourierSummary = () => {
    const filter = {
      search: filters.search,
      page: filters.page || 0,
      page_size: filters.page_size || 50,
      to_be_delivered: filters.to_be_delivered || '0',
      courier_id: filters.courier_id,
    }
    setTableLoading(true)
    getCourierBookings(filter).subscribe((res: any) => {
      setTotalRows(res.response._meta.total)
      setCourierSummary(res.response.data)
      setTableLoading(false)
    })
  }

  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false)

  const tenant_info: any = JSON.parse(
    localStorage.getItem('tenant_info') || '{}',
  )
  const columns = [
    {
      dataKey: 'tracking_id',
      name: 'CN #',
      sortable: true,
      selector: (row) => row.tracking_id || '--',
    },

    {
      dataKey: 'ref_no',
      name: 'Ref #',
      sortable: true,
      selector: (row) => row.ref_no || '--',
    },

    {
      dataKey: 'booking_date',
      name: 'Booking Date',
      minWidth: '120px',
      sortable: true,
      selector: (row) => row.booking_date || '--',
    },
    {
      dataKey: 'consignee',
      name: 'Consignee',
      minWidth: '200px',
      sortable: true,
      selector: (row) => row.consignee || '--',
    },
    {
      dataKey: 'weight',
      name: 'Weight',
      sortable: true,
      selector: (row) => row.weight || '--',
    },
    {
      dataKey: 'cod_amount',
      width: '11%',
      name: `COD Total (${tenant_info.default_currency_symbol})`,
      sortable: true,
      selector: (row) =>
        (
          <PixelCurrency
            hideSymbol={true}
            value={row.cod_amount}
            currency={'USD'}
          />
        ) || '--',
    },
    {
      dataKey: 'cod_amount_received',
      width: '14%',
      name: `COD Received (${tenant_info.default_currency_symbol})`,
      sortable: true,
      selector: (row) =>
        (
          <PixelCurrency
            hideSymbol={true}
            value={row.cod_amount_received}
            currency={'USD'}
          />
        ) || '--',
    },
    {
      dataKey: 'shipping_chg',
      width: '14%',
      name: `Shipping Cost (${tenant_info.default_currency_symbol})`,
      sortable: true,
      selector: (row) =>
        (
          <PixelCurrency
            hideSymbol={true}
            value={row.shipping_chg}
            currency={'USD'}
          />
        ) || '--',
    },
    {
      dataKey: 'delivery_status',
      name: 'Status',
      sortable: true,
      selector: (row) => row.delivery_status || '--',
    },
    {
      dataKey: 'shipper',
      name: 'Courier',
      sortable: true,
      selector: (row) => row.shipper || '--',
    },
    {
      dataKey: 'actions',
      name: 'Actions',
      selector: (row) => <PixelTableAction row={row} action={actions} />,
    },
  ]
  const actions = [
    {
      title: 'Add Payment',
      icon: (
        <Section>
          <PixelIcon icon={faMoneyCheckDollar} />
        </Section>
      ),
      disabled: (row) => {
        return row['courier_type'] === 'api' && row['status'] !== 'inProcess'
      },

      clickHandler: (row) => {
        setSelectedBooking(row)
        setShowModal(true)
      },
    },
  ]
  const handlePageChange = (page) => {
    if (filters.page === page - 1) return
    setFilters({
      ...filters,
      page: page - 1,
    })
  }
  const handlePerRowsChange = async (newPerPage) => {
    setFilters({
      ...filters,
      page_size: newPerPage,
    })
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              padding=" 5px 20px"
              justifyContent="flex-end"
              gap="5px"
            >
              <DcDiv style={{ width: '20%' }}>
                <DcInput
                  inputSize="small"
                  showsearchicon={0}
                  placeholder="Search"
                  name="search"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value)
                    debounceFn(e.target.value)
                    setResetPaginationToggle(e.target.value.length > 0)
                  }}
                />
              </DcDiv>
              <DcDiv style={{ width: '20%' }}>
                <DcDropDown
                  dropdownSize="sm"
                  placeholder="Booking"
                  options={bookingsTypeFilter}
                  value={filters.to_be_delivered}
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      to_be_delivered: e.target.value,
                    })
                  }}
                />
              </DcDiv>

              <DcDiv style={{ width: '20%' }}>
                <DcDropDown
                  dropdownSize="sm"
                  placeholder="Select Courier"
                  options={[
                    {
                      courier_name: 'Select Courier',
                      courier_id: '',
                    },
                    ...courierList,
                  ].map((item: any) => {
                    return {
                      label: item.courier_name,
                      value: item.courier_id,
                    }
                  })}
                  value={filters.courier_id}
                  onChange={(e) => {
                    if (e.target.value === 'all') {
                      const f = { ...filters }
                      delete f['rider_id']
                      delete f['courier_id']
                      setFilters(f)
                    } else {
                      const f = { ...filters }
                      // f["rider_id"] = null;
                      f['courier_id'] = e.target.value
                      const courier = courierList.filter((c) => {
                        return c['courier_id'] === e.target.value
                      })
                      setFilters(f)
                      setRiderList(
                        courier[0] && courier[0].riders
                          ? courier[0].riders
                          : [],
                      )
                    }
                  }}
                />
              </DcDiv>

              {riderList.length > 0 && (
                <DcDiv style={{ width: '15%' }}>
                  <DcDropDown
                    dropdownSize="sm"
                    placeholder="Select Rider"
                    options={[
                      {
                        rider_id: null,
                        rider_name: 'Select Rider',
                      },
                      ...riderList,
                    ].map((rider) => {
                      return {
                        label: rider.rider_name,
                        value: rider.rider_id,
                      }
                    })}
                    value={filters.rider_id}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        rider_id: e.target.value,
                      })
                    }}
                  />
                </DcDiv>
              )}
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            {' '}
            <PixelTable
              columns={columns}
              data={courierSummary}
              paginationRowsPerPageOptions={[50, 100, 250, 500]}
              fixedHeader
              paginationPerPage={50}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              paginationDefaultPage={Number(filters.page || 0) + 1}
              fixedHeaderScrollHeight="calc(100vh - 160px)"
              progressPending={tableLoading}
              paginationTotalRows={totalRows}
              paginationResetDefaultPage={resetPaginationToggle}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <PixelModal
        title={'Update Payment'}
        handleClose={() => setShowModal(false)}
        show={showModal}
      >
        <UpdateCourierBookingPayments
          selectedBooking={selectedBooking}
          handleClose={() => {
            setShowModal(false)
          }}
        />
      </PixelModal>
    </>
  )
}

export default Bookings
